export const APIActionTypes = {
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_IS_Downloading: "SET_IS_Downloading",
  SET_SINGNALR_CONNECTION: "SET_SINGNALR_CONNECTION",
  SET_CALCULATOR_CONTEXT: "SET_CALCULATOR_CONTEXT",
};
